import {Col, Row} from 'antd';
import {useIntl} from 'react-intl';
import {useFormikContext} from 'formik';
import FormItem from '../../../../../../shared/components/form-item';
import {Input} from 'formik-antd';
import {
  getLocaleValue,
  handleChangeLocales,
} from 'src/shared/functions/change-locales';

interface IValueModalLanguageProps {
  code?: string;
  index?: number;
}
const ValueModalLanguage = (props: IValueModalLanguageProps) => {
  const {code} = props;

  const {messages} = useIntl();

  const {setFieldValue, values} = useFormikContext<any>();

  return (
    <>
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <FormItem
            name='name'
            label={messages[
              'productAttributes.productAttributesPredefinedValues.name'
            ].toString()}
            titleTooltip={messages[
              'tooltip.productAttributes.productAttributesPredefinedValues.name'
            ].toString()}
            isTooltip
            fieldCommponent={
              <Input
                name='name'
                value={getLocaleValue(values?.locales, code, 'name')}
                onChange={(value) =>
                  handleChangeLocales(
                    values?.locales,
                    setFieldValue,
                    `locales`,
                    code,
                    'name',
                    value.target.value,
                  )
                }
              />
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default ValueModalLanguage;
